import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const TvGuideLoadable = loadable(() => import('./TvGuide'), {
  resolveComponent: components => components.TvGuide
});

export const TvGuide = WithLazyHydration(TvGuideLoadable, {
  name: 'TvGuide'
});
